import { render } from "./WalletTableItem.vue?vue&type=template&id=2ae71385&scoped=true"
import script from "./WalletTableItem.vue?vue&type=script&lang=js"
export * from "./WalletTableItem.vue?vue&type=script&lang=js"

import "./WalletTableItem.vue?vue&type=style&index=0&id=2ae71385&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src338202144/src/web-app-vue-3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ae71385"]])

export default __exports__